document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector("#hoursOpenStatus")) {
        const now = new Date();
        const currentDayOfWeek = now.getDay(); // Sunday - 0, Monday - 1, ..., Saturday - 6
        const currentTime = `${now.getHours()}:${now.getMinutes()}`;

        // Function to check if current time is within a given time range
        function isTimeInRange(startTime, endTime, currentTime) {
            const [currentHours, currentMinutes] = currentTime.split(':').map(Number);
            const [startHours, startMinutes] = convertToMilitaryTime(startTime).split(':').map(Number);
            const [endHours, endMinutes] = convertToMilitaryTime(endTime).split(':').map(Number);

            const currentDate = new Date();
            const startDate = new Date(currentDate.setHours(startHours, startMinutes));
            const endDate = new Date(currentDate.setHours(endHours, endMinutes));
            const current = new Date(currentDate.setHours(currentHours, currentMinutes));

            return current >= startDate && current <= endDate;
        }

        function convertToMilitaryTime(timeStr) {
            const [time, period] = timeStr.split(' ');
            let [hours, minutes] = time.split(':');

            hours = parseInt(hours, 10);

            if (period.toLowerCase() === 'pm' && hours < 12) {
                hours += 12;
            } else if (period.toLowerCase() === 'am' && hours === 12) {
                hours = 0;
            }

            hours = ('0' + hours).slice(-2);
            return `${hours}:${minutes}`;
        }

        function isDayInRange(dayRange, currentDayOfWeek) {
            const dayMappings = {
                'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6, 'Sun': 0,
            };
            const days = dayRange.split(' – ');
            let startDay = dayMappings[days[0]];
            let endDay = dayMappings[days[1]];

            if (startDay > endDay) {
                return currentDayOfWeek >= startDay || currentDayOfWeek <= endDay;
            } else {
                return currentDayOfWeek >= startDay && currentDayOfWeek <= endDay;
            }
        }

        // Function to parse and check hours for each table
        function updateStatusBasedOnHours(table) {
            let isOpen = false;
            const rows = table.querySelectorAll('tbody tr');

            rows.forEach(row => {
                const dayCellText = row.cells[0].textContent.trim();
                const hoursCellText = row.cells[1].textContent.trim();
                const [openTime, closeTime] = hoursCellText.split(' – ');
                if (dayCellText.includes(' – ')) {
                    if (isDayInRange(dayCellText, currentDayOfWeek) && isTimeInRange(openTime, closeTime, currentTime)) {
                        isOpen = true;
                    }
                } else {
                    const dayMappings = {
                        'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6, 'Sun': 0,
                    };

                    // Check if the current day matches the day(s) in the row
                    Object.keys(dayMappings).forEach(day => {
                        if (dayCellText.includes(day) && currentDayOfWeek === dayMappings[day] && isTimeInRange(openTime, closeTime, currentTime)) {
                            isOpen = true;
                        }
                    });
                }


            });

            return isOpen;
        }

        const officeHoursTable = document.querySelector('.timetable-wrapper table:nth-of-type(1)');
        const accessHoursTable = document.querySelector('.timetable-wrapper table:nth-of-type(2)');
        const officeOpen = updateStatusBasedOnHours(officeHoursTable);
        const accessOpen = updateStatusBasedOnHours(accessHoursTable);

        document.querySelector("#hoursOpenStatus").textContent = officeOpen ? 'Open' : 'Closed';
        document.querySelector("#officeOpenStatus").textContent = officeOpen ? "Open" : "Closed";
        document.querySelector("#accessOpenStatus").textContent = accessOpen ? "Open" : "Closed";
    }
});